(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-video-review"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const videoSections = document.querySelectorAll('.video-wrapper');

    videoSections.forEach((wrapper) => {
      const video = wrapper.querySelector('video');
      const playPauseBtn = wrapper.querySelector('.play-pause-btn');
      const muteBtn = wrapper.querySelector('.mute-btn');

      const playPauseIcon = playPauseBtn.querySelector('img');
      const muteIcon = muteBtn.querySelector('img');

      playPauseBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          playPauseIcon.src = 'https://cdn.shopify.com/s/files/1/0639/7945/4636/files/pause.svg';
          playPauseIcon.alt = 'Pause';
        } else {
          video.pause();
          playPauseIcon.src = 'https://cdn.shopify.com/s/files/1/0639/7945/4636/files/play.svg';
          playPauseIcon.alt = 'Play';
        }
      });

      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (video.muted) {
          muteIcon.src = 'https://cdn.shopify.com/s/files/1/0639/7945/4636/files/mute.svg';
          muteIcon.alt = 'Muted';
        } else {
          muteIcon.src = 'https://cdn.shopify.com/s/files/1/0639/7945/4636/files/volume.svg';
          muteIcon.alt = 'Volume';
        }
      });

      video.addEventListener('ended', function () {
        playPauseIcon.src = 'https://cdn.shopify.com/s/files/1/0639/7945/4636/files/play.svg';
        playPauseIcon.alt = 'Play';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
